var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16.59,
  height: 16.59,
  viewBox: "0 0 16.59 16.59"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-16 729)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8.295,
  cy: 8.295,
  r: 8.295,
  transform: "translate(16 -729)",
  fill: "#ffc53d"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(20 -725)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 4.5,
  r: 4.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 4.5,
  r: 4,
  fill: "none"
})))));
export default __webpack_public_path__ + "static/media/open-order-icon.7f14de80.svg";
export { SvgComponent as ReactComponent };